var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[
    'header',
    {'header--screen': _vm.$nuxt.$breakpoints.sLg && _vm.isNavOpened}
  ]},[_c('div',{staticClass:"header__wrapper"},[_c('header-aside'),_vm._v(" "),_c('header-main',{attrs:{"menu":_vm.menuGroupingByServices[_vm.$i18n.locale],"on-toggle":_vm.toggleNav}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }